import React, { useEffect, useState, useRef } from 'react'
import { images } from 'theme'
import { useNavigate, useLocation } from 'react-router-dom'
import moment from 'moment/moment'
import { Anchorme } from 'react-anchorme'
import { useDispatch, useSelector } from 'react-redux'
import css from '../pendingApproval/pending.module.css'
import style from './consultation.module.css'
import { path } from '../../utils/const'
import BackComponent from '../../components/BackComponent/BackComponent'
import PopupModal from '../../components/ToggleModal/PopupModal'
import { database, storageRef } from '../../utils/firebase'
import { isAwaitingMedicalNotePayment } from '../../utils/functions'
// eslint-disable-next-line import/named
import { actions } from '../../slices/patient.slices'
import { endDelegateChat } from 'utils/network'
import MedicalListToggle from '../../components/medicalList/MedicalListToggle'
import { delegateChatCloseTask, generateSoapNotesDocument, mergePdfs } from '../labRequisitions/APIS'
const { Modal } = require('antd');

const Consultation = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const [age, setAge] = useState(0)
  const [ageInYear, setAgeInYear] = useState(0)
  const [name, setName] = useState('')
  const [patientDate, setPatientDate] = useState('')
  const [showInitialModal, setShowInitialModal] = useState(false)
  const [initialMessage, setInitialMessage] = useState('')
  const [gender, setGender] = useState('')
  const [healthCardNumber, setHealthCardNumber] = useState('')
  const [delegateListData, setDelegateListData] = useState('')
  const [communicationMode, setCommunicationMode] = useState('NA')
  const [needMedicalPayment, setNeedMedicalPayment] = useState(false)
  const [needMedicalNotePdf, setNeedMedicalNotePdf] = useState(false)
  const [isSelectDisabled, setIsSelectDisabled] = useState(false)
  const [generatingSoap, setGeneratingSoap] = useState(false);
  const [soapGenMessage, setSoapGenMessage] = useState({ type: '', message: '' });
  const [existingSoapDoc, setExistingSoapDoc] = useState(null);

  // Get doctor info from Redux instead of local state
  const { me } = useSelector((state) => state.app)
  const [openConvo, setOpenConvo] = useState({})
  const [isOpen, setIsOpen] = useState(false)
  const [loadingConsult, setLoadingConsult] = useState(false)
  const past = query.get('Past')
  const archiveId = query.get('archiveId')

  console.log('get archiveId', archiveId)

  const dispatch = useDispatch()

  const patient = useSelector((state) => state.patient.patientData)

  const archiveData = useSelector((state) => state.patient.archiveData)

  const delegateConvoData = useSelector((state) => state.patient.delegateData)

  const archiveID = useSelector((state) => state.patient.archiveId)

  console.log('delegate archiveID', archiveID)

  const patientID = useSelector((state) => state.patient.patientID)
  const archiveIdRef = useRef(archiveID); 

  let isFromMedicalNote = 'medicalNote';
  let isFromPrescriptionNote = 'prescriptionNote';
  let isFromLabNote = 'labNote';
  let isFromImagingNote = 'imagingNote';
  let isEnabledImaging = archiveData?.imagingData || delegateConvoData?.imagingData || false;
  let isEnabledLab = archiveData?.labRequisitionData || delegateConvoData?.labRequisitionData || false;
  let isEnabledMedicalNote = archiveData?.medicalNotesData || delegateConvoData?.medicalNotesData || false;
  let isEnabledPrescription= archiveData?.prescriptionData || delegateConvoData?.prescriptionData || false;

  useEffect(() => {
    const conditions = [];
    if (isEnabledMedicalNote) conditions.push('a Medical Note');
    if (isEnabledLab) conditions.push('a Lab Report');
    if (isEnabledImaging) conditions.push('an Imaging Report');
    if (isEnabledPrescription) conditions.push('a Prescription');
  
    if (conditions.length > 0) {
      const lastItem = conditions.pop();
      const formattedConditions = conditions.length > 0
        ? `${conditions.join(', ')} and ${lastItem}`
        : lastItem;
  
      setInitialMessage(`The following items have been issued to the patient ${formattedConditions}. Please review all of them first and either approve or decline each one before the chat can be initiated.`);
      setShowInitialModal(true);
    }
  }, [isEnabledImaging, isEnabledLab, isEnabledMedicalNote, isEnabledPrescription]);
  
  const closeInitialModal = () => {
    setShowInitialModal(false);
  };

  useEffect(() => {
  if (archiveId) {
    dispatch(actions.fetchDelegateData(archiveId))
    dispatch(actions.fetchArchiveOpenData(archiveId))
  }
}, [archiveId, dispatch])


useEffect(() => {
  if (!archiveID) return;

  // Reference to medical notes for this archiveID
  const medicalNoteRef = database.ref(`/medicalNotes/${archiveID}`);

  // Listener for real-time updates
  const listener = medicalNoteRef.on('value', (snapshot) => {
    const medicalNoteData = snapshot.toJSON() || null;

    console.log('medical note data (listener):', medicalNoteData);

    // "Pending payment for sick notes" while the note waits for its first
    // payment; the Review button once it is paid. One rule, shared with
    // shouldSkipMedicalNote and the backend. (The first branch of the old chain,
    // `!status=='declined'`, could never be true, and refunded notes were not
    // considered.)
    setNeedMedicalPayment(isAwaitingMedicalNotePayment(medicalNoteData));
    if(!medicalNoteData?.medicalNotePdf) {
      setNeedMedicalNotePdf(true);
    }
    else{
      setNeedMedicalNotePdf(false);
    }
  });

  // Cleanup listener when component unmounts or archiveID changes
  return () => medicalNoteRef.off('value', listener);

}, [archiveID]);


console.log('need medical payment', needMedicalPayment)

  // Check if select box should be disabled (5 days after endTimestamp)
  useEffect(() => {
    // Check for endTimestamp in multiple places
    let endTimestamp = null;
    if(delegateConvoData && delegateConvoData?.communicationMode){
        setCommunicationMode(delegateConvoData?.communicationMode);
    }
    // First try from delegateConvoData.endTimestamp
    if (delegateConvoData && delegateConvoData?.endTimestamp) {
      endTimestamp = delegateConvoData.endTimestamp;
    } 
    // Then try from patient's history_conversations if available
    else if (patient && patient?.history_conversations && archiveId) {
      const chatData = patient.history_conversations[archiveId];
      if (chatData && chatData.timestamp) {
        endTimestamp = chatData.timestamp;
      }
    } 
    // Finally fall back to delegateConvoData timestamp
    else if (delegateConvoData && delegateConvoData?.timestamp) {
      endTimestamp = delegateConvoData.timestamp;
    }
    
    // If we found an endTimestamp, check if it's more than 5 days old
    if (endTimestamp) {
      const endDate = new Date(endTimestamp);
      const fiveDaysLater = new Date(endDate);
      fiveDaysLater.setDate(fiveDaysLater.getDate() + 5);
      
      // If current date is more than 5 days after endTimestamp, disable select
      const isDisabled = new Date() > fiveDaysLater;
      setIsSelectDisabled(isDisabled);
      
      if (isDisabled) {
        console.log('Communication select disabled: More than 5 days since end timestamp');
      }
    } else {
      // No timestamp found, keep select enabled
      setIsSelectDisabled(false);
    }
  }, [delegateConvoData, patient, archiveId]);


  useEffect(async () => {
    if (archiveID !== archiveId) {
      console.log('inside if condition')
      if (archiveID && archiveID !== archiveIdRef.current) {
      console.log('inside second if condition')
        archiveIdRef.current = archiveID;
      dispatch(actions.fetchDelegateData(archiveId))
      dispatch(actions.fetchArchiveOpenData(archiveId))
      }
    }

    if (delegateConvoData) {
      const date = moment(delegateConvoData?.DOB, 'MMMM DD YYYY')
      const years = moment().diff(date, 'years')
      setAgeInYear(years)
    }

    if (patient && archiveData) {
      const { conversations } = patient || {}

      setOpenConvo(conversations)
      let date = moment(patient?.DOB, 'MMMM DD YYYY')
      let years = moment().diff(date, 'years')

      if (
        archiveData?.owner &&
        patient?.profiles &&
        patient?.profiles[archiveData?.owner]
      ) {
        date = moment(patient?.profiles[archiveData?.owner].DOB, 'MMMM DD YYYY')

        const convertDate = date.format('MMMM,DD,YYYY')
        setPatientDate(convertDate)
        years = moment().diff(date, 'years')

        setAge(years)
        setName(
          patient?.profiles[archiveData?.owner].name ||
            patient?.profiles[archiveData?.owner].userName ||
            '',
        )
        setGender(patient?.profiles[archiveData?.owner].gender || '')
        setHealthCardNumber(
          patient?.profiles[archiveData?.owner].healthInsuranceCardNumber || '',
        )
      } else {
        date = moment(patient?.DOB, 'MMMM DD YYYY')

        const convertDate = date.format('MMMM,DD,YYYY')
        setPatientDate(convertDate)

        years = moment().diff(date, 'years')
        setAge(years)
        setName(patient?.name || patient?.userName || '')
        setGender(patient?.gender || '')
        setHealthCardNumber(patient?.healthInsuranceCardNumber || '')
      }
    }
  }, [patient, archiveData, archiveID, archiveId, delegateConvoData])

   // get delegate list data from firebase
   const fetchDelegateListData = async () => {
    const delegateListSnapshot = await database.ref(`/delegateChats/${archiveId}`).once('value')
    const delegateListData = delegateListSnapshot.toJSON() || {}
    setDelegateListData(delegateListData)

  }
      useEffect(() => { 

       fetchDelegateListData()

      },[])

  const endConsult = async () => {
    try {
      setLoadingConsult(true)

      const payload = {
        chatID: delegateConvoData.id,
      }
      await endDelegateChat(payload)
      setLoadingConsult(false)
      navigate(path.activeconsultationpage, { replace: true })
    } catch (e) {
      console.log(e)
      setLoadingConsult(false)
      // eslint-disable-next-line no-undef
      alert('Something went wrong, please try again!')
    }
  }

  const toggleModal = () => {
    setIsOpen((old) => !old)
  }

  const handleCommunicationChange = async (e) => {
    const selectedMode = e.target.value;

    if (selectedMode !== 'NA') {
      // Import Modal from antd for better UI experience

      // Show confirmation dialog using Ant Design's Modal
      Modal.confirm({
        title: 'Confirm Communication Mode',
        content: `Are you sure you want to set communication mode to ${selectedMode}?.`,
        okText: 'Yes',
        cancelText: 'No',
        onOk: async () => {
          // Proceed with setting the mode if user confirmed
          setCommunicationMode(selectedMode);
          console.log("Selected mode:", selectedMode);

          // Auto-append message when mode is selected (not waiting for chat button click)
          if (selectedMode !== 'NA' && delegateConvoData?.conversationID) {
            // Show loading state
            setGeneratingSoap(true);
            setSoapGenMessage({ type: 'info', message: 'Updating communication mode and generating SOAP notes...' });

            const messageObject = createMessageObject(selectedMode);
            if (messageObject) {
              try {
                // Generate a new key for the message
                const newMessageRef = database.ref(`conversations/${delegateConvoData?.conversationID}`).push();
                const newMessageKey = newMessageRef.key;

                console.log("Auto-appending message:", messageObject);

                // Create a multi-path update object
                const updates = {};

                // Add message to conversation
                updates[`conversations/${delegateConvoData.conversationID}/${newMessageKey}`] = messageObject;
                if (archiveId) {
                  // Update delegateChats/archiveId status to active and remove action key
                  updates[`delegateChats/${archiveId}/status`] = 'active';
                  updates[`delegateChats/${archiveId}/action`] = null;
                  updates[`delegateChats/${archiveId}/unReadCount`] = null;

                  updates[`delegateChats/${archiveId}/communicationMode`] = selectedMode;

                }

                // Perform all updates in a single operation
                await database.ref().update(updates);

                // Update local delegate list data to reflect changes
                setDelegateListData(prevData => ({
                  ...prevData,
                  status: 'active',
                  action: null
                }));

                console.log(`Message ${newMessageKey} added and delegateChats/${archiveId} updated in a single transaction`);

                // Update message to indicate SOAP note generation
                setSoapGenMessage({ type: 'info', message: 'Communication mode updated. Generating SOAP notes document...' });

                // After message is appended, generate SOAP notes with appropriate communication mode text
                await generateSOAPWithCommunicationMode(selectedMode);

                // Prepare payload for API request
                const payload = {
                  createTask: false
                };

                console.log('SOAP Notes Generation Payload:', payload);

                // Call the API to generate SOAP notes document
                const response = await delegateChatCloseTask(payload).catch(e => {
                  console.error(e);
                  throw new Error('Error while generating SOAP notes document.');
                });
                console.log('SOAP Notes Generation Response:', response);


              } catch (error) {
                console.error('Error updating Firebase:', error);
                setSoapGenMessage({ type: 'error', message: 'Failed to update communication mode' });
                setGeneratingSoap(false);
              }
            }
          } else {
            setGeneratingSoap(false);
            setSoapGenMessage({ type: '', message: '' });
          }
        },
        onCancel: () => {
          // Reset select to previous value when canceled
          setCommunicationMode(communicationMode);
        }
      });

      // Reset immediately since the actual change will happen after confirmation
      e.target.value = communicationMode;
    } else {
      // If NA is selected, simply set the mode without confirmation
      setCommunicationMode(selectedMode);
    }
  };

  const createMessageObject = (mode) => {
    // Get content based on communication mode
    let messageContent = '';
    let messageType = 'text';

    // Get patient name, phone number and doctor name for dynamic messages
    const patientName = delegateConvoData?.patientName || 'Patient';
    const patientPhone = patient?.phone_number || '[Phone Number]';
    const doctorName = me?.doctorName || me?.name || 'Doctor';
    console.log("mode", mode);

    switch (mode) {
      case 'voicemail':
        messageContent = `Hello ${patientName}, this is your supervising physician ${doctorName}. I tried reaching you at ${patientPhone} but was unable to get in touch. If you have any further questions, please reply to this message here in the app and I'll be happy to assist you.`;
        messageType = 'voicemail';
        break;
      case 'voice':
        messageContent = `Hello ${patientName}, this is your supervising physician ${doctorName}. It was a pleasure connecting with you over the phone. If you have any additional questions or need further clarification, please feel free to reply to this message here in the app.`;
        messageType = 'voice';
        break;
      case 'video':
        messageContent = `Hello ${patientName}, this is your supervising physician ${doctorName}. It was nice speaking with you today over our video call. If you have any additional questions or concerns, please feel free to message me here in the app.`;
        messageType = 'video';
        break;
      case 'call':
        messageContent = `Hello ${patientName}, this is your supervising physician ${doctorName}. It was a pleasure connecting with you over the phone. If you have any additional questions or need further clarification, please feel free to reply to this message here in the app.`;
        messageType = 'call';
        break;
      case 'unreachable':
        messageContent = `Hello ${patientName}, this is your supervising physician ${doctorName}. I attempted to reach you at ${patientPhone} but was unable to connect. Please reply to this message here in the app if you have any additional questions or concerns and would like me to call again later.`;
        messageType = 'unreachable';
        break;
      case 'sms':
        messageContent = `Hello ${patientName}, this is your supervising physician ${doctorName}. I tried reaching you at ${patientPhone} but was unable to get in touch. Please reply to this message here in the app if you have any additional questions or concerns and would like me to call again later.`;
        messageType = 'sms';
        break;
      default:
        return null;
    }

    // Create the message object following the structure - using Redux doctor info
    return {
      type: "text",
      timestamp: Date.now(),
      content: messageContent,
      fromID: me.id,
      toID: patientID,
      isRead: false,
      doctorName: me.doctorName || "",
      doctorImgURL: me.profileImageURL || me.photoURL,
    };
  };


  // Helper function to get communication mode text for SOAP notes
  const getCommunicationModeText = (mode) => {
    switch (mode) {
      case 'voicemail':
        return 'Mode of communication: Text chat completed with patient, phone call made to patient - unsuccessful, voicemail left to call back for any concerns';
      case 'voice':
        return 'Mode of communication: Phone call completed with patient.';
      case 'video':
        return 'Mode of communication: Text chat completed with the patient, video call conducted successfully';
      case 'call':
        return 'Mode of communication: Text chat completed with the patient. Phone call made successfully and addressed any concerns.';
      case 'unreachable':
        return 'Mode of communication: Text chat completed. Phone call made unsuccessfully. Unable to reach the patient.';
      case 'sms':
        return 'Mode of communication: Text chat completed. Phone call made unsuccessfully, SMS sent.';
      default:
        return 'Mode of communication: Text chat completed with patient.';
    }
  };

  // Function to generate SOAP notes with communication mode
  const generateSOAPWithCommunicationMode = async (mode) => {
    try {
      // Get the communication mode text to add to findings
      const communicationModeText = getCommunicationModeText(mode);

      // Call the main SOAP notes generation function with the communication mode text
      await generateAndAddSOAPNotes(communicationModeText);

    } catch (error) {
      console.error('Error in generateSOAPWithCommunicationMode:', error);
      setSoapGenMessage({
        type: 'error',
        message: `Failed to generate SOAP Notes: ${error.message}`
      });
      setGeneratingSoap(false);
    }
  };

  // Function to generate SOAP Notes document and update conversation data
  const generateAndAddSOAPNotes = async (communicationModeText = '') => {
    try {
      setGeneratingSoap(true);
      setSoapGenMessage({ type: 'info', message: 'Generating SOAP Notes document and gathering attachments...' });

      // Check if we have the necessary data
      if (!archiveData || !patient || !delegateConvoData?.conversationID) {
        setSoapGenMessage({ type: 'error', message: 'Missing required data for SOAP notes generation' });
        setGeneratingSoap(false);
        return;
      }

      // Get today's date formatted
      const todaysDate = moment().format('YYYY-MM-DD');

      // Get profile data based on the structure in your code
      let profile = patient;
      if (archiveData?.owner && patient?.profiles && patient?.profiles[archiveData?.owner]) {
        profile = patient?.profiles[archiveData?.owner];
      }

      // Create SOAP notes data from archive data
      // Extract any existing plan content from archiveData or delegateConvoData
      let existingPlan = archiveData?.soapNotesData?.plan || delegateConvoData?.plan || '';

      // Check if the plan already contains a communication mode text and remove all text after that
      const communicationModeIndex = existingPlan.indexOf('Mode of communication:');
      if (communicationModeIndex !== -1) {
        // Remove everything from the "Mode of communication:" text to the end of the string
        existingPlan = existingPlan.substring(0, communicationModeIndex).trim();
      }

      // Create SOAP notes data from archive data with the cleaned plan plus new communication mode text
      const soapNotes = {
        findings: archiveData?.soapNotesData?.findings || delegateConvoData?.findings || '',
        assessment: archiveData?.soapNotesData?.assessment || delegateConvoData?.assessment || '',
        symptoms: archiveData?.soapNotesData?.symptoms || delegateConvoData?.symptoms || '',
        plan: existingPlan + (communicationModeText ? `\n\n${communicationModeText}` : ''),
        interactionType: archiveData?.soapNotesData?.interactionType || '', // Default to resolved, adjust as needed
      };

      // Prepare payload for API request
      const payload = {
        findings: soapNotes.findings || '',
        assessment: soapNotes.assessment || '',
        issue: soapNotes.symptoms || '',
        plan: soapNotes.plan || '',
        patientName: profile?.name || profile?.userName || '',
        patientDOB: profile?.DOB || '',
        patientGender: profile?.gender || '',
        patientPhone: patient?.phone_number || '',
        encounterDate: todaysDate,
        patientHealthCardNumber: profile?.healthInsuranceCardNumber || '',
        doctorName: me?.doctorName || me?.name || '',
        doctorLicense: me?.license || '',
        country: patient?.country || '',
        state: patient?.state || '',
        adminDoctor: me || {}, // Pass the current doctor info
      };

      console.log('SOAP Notes Generation Payload:', payload);

      // Call the API to generate SOAP notes document
      const response = await generateSoapNotesDocument(payload).catch(e => {
        console.error(e);
        throw new Error('Error while generating SOAP notes document.');
      });

      console.log('SOAP NOTES RESPONSE:', response);

      // Check if response is valid and contains finalLink
      if (!response || !response.finalLink) {
        throw new Error('Invalid response from SOAP notes generation service');
      }

      // Initialize link object with SOAP Notes link
      const link = { soapNotes: response.finalLink };
      console.log("archiveId", archiveId || "not found archive ID");

      // Gather all attachment links for merging
      const attachmentLinks = [];
      setSoapGenMessage({ type: 'info', message: 'Gathering medical notes, lab and imaging documents...' });



        // Check for physio prescription data in the archive data
      if (archiveData?.physioPrescriptionData && archiveData.physioPrescriptionData.approvalStatus === 'approved') {
        if (archiveData.prescriptionspdf) {
          console.log('Adding physio prescription:', archiveData.prescriptionspdf);
          attachmentLinks.push(archiveData.prescriptionspdf);
        }
      }
      
       if (archiveData?.soapAttachments && Array.isArray(archiveData?.soapAttachments)) {
          archiveData.soapAttachments.forEach((soapAttachment) => {
            attachmentLinks.push(soapAttachment)
          })
        }
      // Get medical notes from patient redux data
      if (patient?.historyMedicalNotes && patient.historyMedicalNotes[archiveId]) {
        const medicalNoteData = patient.historyMedicalNotes[archiveId];
        if (medicalNoteData.notes) {
          // Extract all medical note files
          Object.values(medicalNoteData.notes).forEach(note => {
            if (note.file) {
              console.log('Adding medical note:', note.file);
              attachmentLinks.push(note.file);
            }
          });
        }
      }

      // Get lab requisitions from patient redux data
      if (patient?.historyLabs && patient.historyLabs[archiveId]) {
        const labData = patient.historyLabs[archiveId];
        if (labData.labForms) {
          // Extract all lab form files
          Object.values(labData.labForms).forEach(form => {
            if (form.file) {
              console.log('Adding lab form:', form.file);
              attachmentLinks.push(form.file);
            }
          });
        }
        if (labData.labResults) {
          // Extract all lab result files
          Object.values(labData.labResults).forEach(result => {
            if (result.file) {
              console.log('Adding lab result:', result.file);
              attachmentLinks.push(result.file);
            }
          });
        }

      }

      // Get imaging requisitions if they exist
      if (patient?.historyImaging && patient.historyImaging[archiveId]) {
        const imagingData = patient.historyImaging[archiveId];
        if (imagingData.forms) {
          // Extract all imaging form files
          Object.values(imagingData.forms).forEach(form => {
            if (form.file) {
              console.log('Adding imaging form:', form.file);
              attachmentLinks.push(form.file);
            }
          });
        }
      }

      // // Get prescription PDFs if they exist
      // if (patient?.historyPrescriptions && patient.historyPrescriptions[archiveId]) {
      //   const prescriptionData = patient.historyPrescriptions[archiveId];
      //   if (prescriptionData.prescriptions) {
      //     // Extract all prescription PDFs
      //     Object.values(prescriptionData.prescriptions).forEach(prescription => {
      //       if (prescription.pdfLink) {
      //         console.log('Adding prescription:', prescription.pdfLink);
      //         attachmentLinks.push(prescription.pdfLink);
      //       }
      //     });
      //   }
      // }

      // Create updates object for Firebase
      const conversationID = archiveId;
      const updates = {};

      // If we have SOAP notes and attachments, merge them
      if (link.soapNotes && attachmentLinks.length > 0) {
        setSoapGenMessage({ type: 'info', message: 'Merging SOAP Notes with medical documents...' });

        const soapNotesMergedPdf = {
          pdfLink: link.soapNotes,
          attachmentLinks,
          documentName: `${me?.doctorName || me?.name || ''} - ${profile?.name || ''} - ${todaysDate}`,
        };

        try {
          const mergePdfsResponse = await mergePdfs(soapNotesMergedPdf);
          if (mergePdfsResponse && mergePdfsResponse.finalPdf) {
            console.log('Successfully merged PDFs:', mergePdfsResponse.finalPdf);
            link.soapNotes = mergePdfsResponse.finalPdf;
          } else {
            console.warn('Merge PDF response invalid or missing finalPdf:', mergePdfsResponse);
          }
        } catch (e) {
          console.error('Error merging PDFs:', e);
          setSoapGenMessage({
            type: 'warning',
            message: 'Generated SOAP Notes but could not merge with attachments. Proceeding with just SOAP Notes.'
          });
        }
      } else {
        console.log('No attachments found or no SOAP notes link available for merging');
      }

      if (conversationID) {

      // Update conversation data with SOAP notes information
      updates[`delegateChats/${conversationID}/plan`] = soapNotes.plan;
      updates[`delegateChats/${conversationID}/assessment`] = soapNotes.assessment;
      updates[`delegateChats/${conversationID}/findings`] = soapNotes.findings;
      updates[`delegateChats/${conversationID}/symptoms`] = soapNotes.symptoms;
      updates[`delegateChats/${conversationID}/soapnotespdf`] = link.soapNotes;

      if (!archiveData?.physioPrescriptionData) {
      updates[`emrEncounters/${conversationID}/soapnotespdf`] = link.soapNotes;
      // updates[`emrEncounters/${conversationID}/oldsoapnotespdf`] = archiveData?.soapnotespdf || null;
      updates[`emrEncounters/${conversationID}/emr_saved`] = null;
      }

      
      // Add SOAP Notes Data for Edit
      updates[`archiveConversations/${conversationID}/soapNotesData`] = {
        plan: soapNotes.plan,
        assessment: soapNotes.assessment,
        findings: soapNotes.findings,
        symptoms: soapNotes.symptoms,
        interactionType: soapNotes.interactionType

      };

      // Update the soapnotespdf in archiveConversations as well
      updates[`archiveConversations/${conversationID}/soapnotespdf`] = link.soapNotes;

      // Create a new timestamp for the changelog
      const currentTimestamp = Date.now();

      // Add the SOAP notes change to changeLogs
      updates[`archiveConversations/${conversationID}/changeLogs/${currentTimestamp}`] = {
        changes: {
          soapNotes: {
            plan: soapNotes.plan,
            assessment: soapNotes.assessment,
            findings: soapNotes.findings,
            symptoms: soapNotes.symptoms,
            soapnotespdf: link.soapNotes || '',
            oldSoapNotespdf: archiveData?.soapnotespdf || null,
          }
        },
        doctorId: me?.id || '',
        doctorName: me?.doctorName || me?.name || '',
        timestamp: currentTimestamp,
      };
    }

      // Make the Firebase update
      await database.ref().update(updates);

      console.log('SOAP Notes document generated, merged with attachments, and data updated successfully with changelog');

      // Add success message
      setSoapGenMessage({
        type: 'success',
        message: `SOAP Notes generated and merged with ${attachmentLinks.length} attachments. Document link saved to patient record.`
      });

    } catch (error) {
      console.error('Error in generateAndAddSOAPNotes:', error);
      setSoapGenMessage({
        type: 'error',
        message: `Failed to generate SOAP Notes: ${error.message}`
      });
    } finally {
      setGeneratingSoap(false);
    }
  };

  const navigateToChat = async (id, CID) => {
    // Message already sent in handleCommunicationChange function
    // Just navigate to chat
    query.set('fromPast', true)
    query.set("communicationMode", communicationMode);
    const chatPath = path.ChatModule
    const paramsString = query.toString()
    const url = new URL(window.location.href)
    url.search = paramsString
    navigate(chatPath + url.search)
  }
  // eslint-disable-next-line no-shadow
  const ReviewPrescriptions = (archive, patient, fromPath) => {
    query.set('archiveId', archive)
    console.log('from path', fromPath)
    query.set('pathName', fromPath)
    const prescriptionPath = path.reviewprescriptions
    const paramsString = query.toString()
    const url = new URL(window.location.href)
    url.search = paramsString
    navigate(prescriptionPath + url.search)
  }
  return (
    <div>
      <div className={style.consultation}>
        <BackComponent title={'Consultation'} />
      </div>
      <div className={style.line}></div>
      <div className={style.patient}>
        <div>
          <span className={css.bold}>
            {delegateConvoData?.patientName || ''}-
          </span>
          <span>
            {delegateConvoData?.DOB || ''} ({ageInYear || ''})
          </span>
        </div>
      </div>
      <hr className={css.hr}></hr>

      <div className={style.iconAlign}>
        <div className={style.backgroundDiv}>
          {delegateConvoData?.conversationID ? (
            <button
              className={style.backgroundMessage}
              onClick={(event) =>
                navigateToChat(patientID, delegateConvoData?.conversationID)
              }
            >
              <img
                src={images.chatIcon}
                className={style.chatIcon}
                alt="logo"
              />
            </button>
          ) : (
            <button className={style.backgroundMessage}>
              <img
                src={images.disableChat}
                className={style.chatIcon}
                alt="logo"
              />
            </button>
          )}
        </div>
{delegateConvoData?.status !== 'pending' && (
        <div className={style.communicationSelect}>
          <label htmlFor="communicationMode">Mode of Communication:</label>
          <select 
            id="communicationMode" 
            value={communicationMode} 
            onChange={handleCommunicationChange}
            className={style.selectBox}
            disabled={isSelectDisabled}
            title={isSelectDisabled ? "Communication options are disabled after 5 days from end timestamp" : ""}
          >
            <option value="NA">Select Mode</option>
            <option value="voicemail">Voice Mail</option>
            <option value="call">Call Made</option>
            <option value="video">Video Call</option>
            <option value="sms">SMS Sent</option>
            <option value="unreachable">Unreachable</option>
          </select>
          {isSelectDisabled && <div className={style.disabledNotice}></div>}
        </div>
        )}
      </div>
      
      <div className={style.patientInformationRoot}>
        <div className={style.patientInformation}>
          <span className={style.bold}>Patient</span>
          <span>{delegateConvoData?.patientName || ''}</span>

          <span className={style.bold}>Issue</span>
          <span>
            {archiveData?.assessment || delegateConvoData?.assessment || '-'}
          </span>

          <span className={style.bold}>Gender</span>
          <span>{gender}</span>

          <span className={style.bold}>Age</span>
          <span>
            {delegateConvoData?.DOB || ''} ({ageInYear || ''})
          </span>

          <span className={style.bold}>Encounter Date</span>
          <span>
            {moment(new Date(archiveData?.timestamp)).format(
              'MM/DD/YY (HH:mm)',
            )}
          </span>

          <span className={style.bold}>Phone number</span>
          <span>{patient?.phone_number}</span>

          <span className={style.bold}> State</span>
          <span>{patient?.state}</span>

          <span className={style.bold}>Health card #</span>
          <span>{healthCardNumber}</span>

          <span className={style.bold}>Conversation ID</span>
          <span>{archiveId}</span>
        </div>
        <hr className={style.hr}></hr>

        <div className={style.subjective}>
          <span className={style.bold}>Subject symptoms</span>
          <Anchorme target="_blank" className={style.paragraph}>
            {archiveData?.symptoms || delegateConvoData?.symptoms || ''}
          </Anchorme>

          <span className={style.bold}>Objective findings</span>
          <Anchorme target="_blank" className={style.paragraph}>
            {archiveData?.findings || delegateConvoData?.findings || ''}
          </Anchorme>

          <span className={style.bold}>Assessment</span>
          <Anchorme target="_blank" className={style.paragraph}>
            {archiveData?.assessment || delegateConvoData?.assessment || ''}
          </Anchorme>

          <span className={style.bold}>Plan</span>
          <Anchorme target="_blank" className={style.paragraph}>
            {archiveData?.plan || delegateConvoData?.plan || ''}
          </Anchorme>
        </div>
      </div>

      <div className={style.buttonDiv}>
          <button
            className={past ? style.pastConsultationbutton : style.buttonStyle}
            // disabled={!isEnabledPrescription || delegateListData?.prescriptionStatus === 'approved' ||  delegateListData?.prescriptionStatus === 'declined'}
            disabled={!isEnabledPrescription }

            style={{
              backgroundColor:
                delegateListData?.prescriptionStatus === 'approved'
                  ? '#58BD19'
                  : delegateListData?.prescriptionStatus === 'declined'
                  ? '#EC4E4E'
                  : '',
            }}
            onClick={(event) => {
              if (past) ReviewPrescriptions(archiveId, patientID,isFromPrescriptionNote)
              else ReviewPrescriptions(archiveId, patientID, isFromPrescriptionNote)
            }}
          >
            {past ? 'View' : 'Review'} prescriptions
          </button>
          {needMedicalPayment ? <button
          
           className={past ? style.pastConsultationbutton : style.buttonStyle}
          disabled={needMedicalPayment || needMedicalNotePdf || delegateListData?.medicalNoteStatus === 'approved' ||  delegateListData?.medicalNoteStatus === 'declined'}
          style={{
            backgroundColor:
              delegateListData?.medicalNoteStatus === 'approved'
                ? '#58BD19'
                : delegateListData?.medicalNoteStatus === 'declined'
                ? '#EC4E4E'
                : '',
          }}
          >
            Pending payment for sick notes
          </button> : <button 
          // className={style.endButton}>
          className={past ? style.pastConsultationbutton : style.buttonStyle}
          // disabled={!isEnabledMedicalNote ||needMedicalNotePdf || delegateListData?.medicalNoteStatus === 'approved' ||  delegateListData?.medicalNoteStatus === 'declined'}
          disabled={!isEnabledMedicalNote ||needMedicalNotePdf }

          style={{
            backgroundColor:
              delegateListData?.medicalNoteStatus === 'approved'
                ? '#58BD19'
                : delegateListData?.medicalNoteStatus === 'declined'
                ? '#EC4E4E'
                : '',
          }}
          onClick={(event) => {
            
            if (past) ReviewPrescriptions(archiveId, patientID, isFromMedicalNote)
            else ReviewPrescriptions(archiveId, patientID, isFromMedicalNote)
          }}
        >
          {past ? 'View' : 'Review'} sick notes
        </button> }
      
        <button 
        // className={style.endButton}>
        className={past ? style.pastConsultationbutton : style.buttonStyle}
        disabled={!isEnabledImaging}
        style={{
          backgroundColor:
            delegateListData?.imagingStatus === 'approved'
              ? '#58BD19'
              : delegateListData?.imagingStatus === 'declined'
              ? '#EC4E4E'
              : '',
        }}
        onClick={(event) => {
          if (past) ReviewPrescriptions(archiveId, patientID, isFromImagingNote)
          else ReviewPrescriptions(archiveId, patientID, isFromImagingNote)
        }}
      >
          {past ? 'View' : 'Review'} imaging requisition
        </button>


        <button 
        // className={style.endButton}>
        className={past ? style.pastConsultationbutton : style.buttonStyle}
        disabled={!isEnabledLab}
        style={{
          backgroundColor:
            delegateListData?.labStatus === 'approved'
              ? '#58BD19'
              : delegateListData?.labStatus === 'declined'
              ? '#EC4E4E'
              : '',
        }}
        onClick={(event) => {
          if (past) ReviewPrescriptions(archiveId, patientID,isFromLabNote)
          else ReviewPrescriptions(archiveId, patientID, isFromLabNote)
        }}
      >
          {past ? 'View' : 'Review'} lab requisition
        </button>

        {isOpen && (
          <PopupModal
            openConvo={openConvo}
            approve={'End consultation'}
            content={'Are you sure you want to end consultation?'}
            delegateConvoObj={delegateConvoData}
            patientData={patientID}
            loading={loadingConsult}
            handleClick={endConsult}
            toggleModal={toggleModal}
            endconsult={true}
          />
        )}

     {showInitialModal && 
       !(delegateListData?.labStatus === 'approved' || 
        delegateListData?.labStatus === 'declined' || 
        delegateListData?.imagingStatus === 'approved' || 
        delegateListData?.imagingStatus === 'declined' || 
        delegateListData?.medicalNoteStatus === 'approved' || 
        delegateListData?.medicalNoteStatus === 'declined' || 
        past ||
        delegateListData?.status === 'active' ||
        delegateListData?.prescriptionStatus === 'approved' || 
        delegateListData?.prescriptionStatus === 'declined') && (
        <MedicalListToggle
          openConvo={openConvo}
          content={initialMessage}
          delegateConvoObj={delegateConvoData}
          patientData={patientID}
          loading={loadingConsult}
          handleClick={closeInitialModal}
          toggleModal={closeInitialModal}
        />
      )}
      </div>
      <div className={style.buttonContainer}>
        {/* <div className={style.soapButtonWrapper}>
          {delegateConvoData?.conversationID && (
            <>
              {delegateConvoData?.soapnotespdf ? (
                <div className={style.soapDocWrapper}>
                  <button 
                    className={`${style.generateSoapButton} ${style.viewButton}`}
                    onClick={() => window.open(delegateConvoData.soapnotespdf, '_blank')}
                  >
                    View SOAP Document
                  </button>
                  <button 
                    className={style.generateSoapButton} 
                    onClick={() => generateAndAddSOAPNotes()}
                    title="Re-generate SOAP Notes document based on consultation data"
                    disabled={generatingSoap}
                  >
                    {generatingSoap ? 'Generating...' : 'Re-generate SOAP Notes'}
                  </button>
                </div>
              ) : (
                <button 
                  className={style.generateSoapButton} 
                  onClick={() => generateAndAddSOAPNotes()}
                  title="Generate SOAP Notes document based on consultation data"
                  disabled={generatingSoap}
                >
                  {generatingSoap ? 'Generating...' : 'Generate SOAP Notes'}
                </button>
              )}
            </>
          )}
          {soapGenMessage.message && (
            <div className={`${style.soapMessage} ${style[soapGenMessage.type]}`}>
              {soapGenMessage.message}
            </div>
          )}
        </div> */}
        
        {delegateConvoData?.status === 'active' &&
          delegateConvoData?.conversationID ? (
            <button className={style.endConsultButton} onClick={toggleModal}>
              End consultation
            </button>
          ) : (
            <button className={style.endButton}>End consultation</button>
          )}
      </div>
    </div>
  )
}

export default Consultation
